import React from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import EventSource from '../../components/EventSourceComp/EventSourceComp';
import DashboardAbnormalities from './abnormalities/DashboardAbnormalities';
import DashboardRecoveryActions from './recoveryActions/DashboardRecoveryActions';
import DashboardDelays from './delays/DashboardDelays';
import DashboardLostTracking from './lostTracking/DashboardLostTracking';
import {
    canViewAbnormalityDashboard,
    canViewDelayDashboard,
    canViewRecoveryActionDashboard,
    canViewTrackingDashboard,
} from '../../shared/security/isActionAuthorized';
import { getEnvHostname } from '../../shared/utils/environment';
import { createDashboardBreadcrumb } from '../../shared/utils/breadcrumbs';

class Dashboard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            key: this.determineActiveKey(),
        };
    }

    userHasAccessToDashboardTab = key => {
        switch (key) {
            case 1:
                return canViewAbnormalityDashboard();
            case 2:
                return canViewRecoveryActionDashboard();
            case 3:
                return canViewTrackingDashboard();
            case 4:
                return canViewDelayDashboard();
            default:
                return false;
        }
    };

    getInitialDashboardTab = () => {
        if (canViewAbnormalityDashboard()) {
            return 1;
        } else if (canViewRecoveryActionDashboard()) {
            return 2;
        } else if (canViewTrackingDashboard()) {
            return 3;
        } else if (canViewDelayDashboard()) {
            return 4;
        }
        return 0;
    };

    determineActiveKey = () => {
        const storedKey = parseInt(localStorage.getItem('selectedDashboardTab'), 10);

        if (storedKey) {
            return this.userHasAccessToDashboardTab(storedKey) ? storedKey : 0;
        } else {
            this.getInitialDashboardTab();
        }
    };

    handleTabSelect = key => {
        localStorage.setItem('selectedDashboardTab', key);
        this.setState({ key: key });
    };

    render() {
        return (
            <div>
                {createDashboardBreadcrumb()}
                <EventSource url={`https://${getEnvHostname()}/api/messages/dashboard`} />
                <Tabs
                    activeKey={this.state.key}
                    animation={false}
                    unmountOnExit
                    onSelect={this.handleTabSelect}
                    id="controlled-tab"
                >
                    <Tab
                        eventKey={1}
                        title="Abnormalities"
                        disabled={!canViewAbnormalityDashboard()}
                    >
                        <DashboardAbnormalities />
                    </Tab>
                    <Tab
                        eventKey={2}
                        title="Recovery actions"
                        disabled={!canViewRecoveryActionDashboard()}
                    >
                        <DashboardRecoveryActions />
                    </Tab>
                    <Tab eventKey={3} title="Lost tracking" disabled={!canViewTrackingDashboard()}>
                        <DashboardLostTracking />
                    </Tab>
                    <Tab eventKey={4} title="Delays" disabled={!canViewDelayDashboard()}>
                        <DashboardDelays />
                    </Tab>
                </Tabs>
            </div>
        );
    }
}

export default Dashboard;
